<template>
  <div :class="['page_setting', $store.state.app.web_language_wm !== 'en' ? 'c-page_setting' : '']">
    <el-tabs v-model="activeName" @tab-click="change_tab">
      <el-tab-pane :label="$t('view_left_sidebar_page_setting_page_setting_272')" name="basic">
        <base_setting></base_setting>
      </el-tab-pane>
      <el-tab-pane v-if="isFullPage" :label="$t('view_left_sidebar_page_setting_page_setting_273')" name="full_page">
        <full_page_setting @changeTab="change_tab"></full_page_setting>
      </el-tab-pane>
      <el-tab-pane :label="$t('view_left_sidebar_page_setting_page_setting_274')" name="header" v-if="$store.state.myRender.common.header_display == 'true'">
        <header_setting></header_setting>
      </el-tab-pane>
      <el-tab-pane :label="$t('view_left_sidebar_page_setting_page_setting_275')" name="footer" v-if="$store.state.myRender.common.footer_display == 'true'">
        <footer_setting></footer_setting>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import i18n from '../../../language/index'

import {mapState} from 'vuex'
import base_setting from "@/view/left_sidebar/page_setting/base_setting"
import full_page_setting from "@/view/left_sidebar/page_setting/full_page_setting"
import header_setting from "@/view/left_sidebar/page_setting/header_setting"
import footer_setting from "@/view/left_sidebar/page_setting/footer_setting"

export default {
  name: 'page_setting',
  components: {
    base_setting,
    full_page_setting,
    header_setting,
    footer_setting
  },
  computed: {
    ...mapState('left_sidebar', ['styleActive']),
    isFullPage() {
      return String(this.$store.state.app.scrollType) !== 'normal'
    },
  },
  watch: {
    styleActive(val) {
      this.activeName = val
    }
  },
  data() {
    return {
      activeName: 'basic'
    };
  },
  mounted() {
    this.activeName = this.styleActive
  },
  methods: {
    change_tab(tab) {
      this.$store.commit('left_sidebar/set_style_active', tab.name || tab)
    }
  }
};
</script>

<style lang="scss" scoped>
.page_setting {
  /deep/ .el-tabs__header {
    margin: 0;
    padding-left: 20px;
    height: 50px;
    background: #f5f5f5;

    .el-tabs__nav-wrap::after {
      background: transparent;
    }

    .el-tabs__active-bar {
      // width: 60px !important;
    }

    .el-tabs__item {
      height: 50px;
      padding: 0;
      padding-right: 20px;
      line-height: 50px;
      color: #999999;
      font-size: 14px;

      &.is-active {
        color: #0078d7;
        background: transparent;
      }
    }
  }

  .tab_content {
    padding: 20px 30px;
    height: 630px;
    overflow-y: auto;
    overflow-x: hidden;
  }

  &.c-page_setting {
    /deep/ .el-tabs {
    .el-tabs__header {
      .el-tabs__active-bar {
          width: 60px !important;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/left_sidebar/page_setting/page_setting.vue